/* eslint-disable */
import moment from 'moment-timezone'
moment.locale('es')

const $format_date = function (options = undefined) {
  if (!options) {
    return {
      fullDate: '--',
      fullDateName: '--',
      fullDateNameFromNow: '--',
      date: '--',
      time: '--',
      dateTime: '--',
      dateTimeFromNow: '--',
      dateFromNow: '--',
      fromNow: '--',
      sameDateClean: '--',
      sameDateCleanReversed: '--'
    }
  }
  const givenDate = options.date ? options.date : options
  const clientZone = options.clientZone ? options.clientZone : moment.tz.guess(true)
  const serverZone = moment.tz(givenDate, 'Etc/UTC')
  const formatedInClient = serverZone.clone().tz(clientZone)

  const fullDate = formatedInClient.format()
  const fullDateName = formatedInClient.format('dddd DD [de] MMMM, YYYY')
  const date = formatedInClient.format('DD-MM-YYYY')
  const time = formatedInClient.format('HH:mm:ss')
  const fromNow = formatedInClient.fromNow()
  const dateFromNow = `${date} (${fromNow})`
  const sameDateClean = moment.utc(givenDate).format('DD-MM-YYYY')
  const sameDateCleanReversed = moment.utc(givenDate).format('YYYY-MM-DD')
  const fullDateNameFromNow = `${fullDateName} (${fromNow})`
  const dateTime = `${date} ${time}`
  const dateTimeFromNow = `${dateTime} (${fromNow})`
  return {
    fullDate,
    fullDateName,
    fullDateNameFromNow,
    date,
    time,
    dateTime: dateTime,
    dateTimeFromNow: dateTimeFromNow,
    dateFromNow: dateFromNow,
    fromNow,
    sameDateClean,
    sameDateCleanReversed
  }
}

export default {
  install(app, options) {
    app.config.globalProperties.$format_date = $format_date
    app.provide('format_date', $format_date)
  }
}
